import { useMemo } from 'react'
import type { JTLDescription } from '@/lib/api/descriptions'
import {
  CONTENT_FIELDS,
  getFieldValue,
} from '@/components/products/v2/tabs/content/channels/channel-constants'

export function computeChannelCompleteness(desc: JTLDescription | undefined): number {
  if (!desc) return 0
  const filled = CONTENT_FIELDS.filter((f) => getFieldValue(desc, f) !== '').length
  return Math.round((filled / CONTENT_FIELDS.length) * 100)
}

export function useChannelCompleteness(desc: JTLDescription | undefined) {
  return useMemo(() => computeChannelCompleteness(desc), [desc])
}
